import { Auth } from "common";
import React, { useState } from "react";
import { Button, Form, Input, Text, XStack, YStack } from "tamagui";

import { useAuthContext } from "../App";

export const Login = () => {
  const { checkAuthState } = useAuthContext();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      setError("Please enter both username and password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      console.log("Attempting to login with:", { username, password });
      await Auth.signIn(username, password);
      // Trigger auth state check which will cause navigation to dashboard
      await checkAuthState();
    } catch (err: any) {
      console.error("Login error:", err);
      setError(err.message || "Failed to login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <YStack
      flex={1}
      backgroundColor="$background"
      paddingHorizontal="$4"
      alignItems="center"
      justifyContent="center"
    >
      <YStack
        width="100%"
        maxWidth={400}
        padding="$6"
        backgroundColor="$backgroundHover"
        borderRadius="$4"
        space="$4"
      >
        <Text
          fontSize="$7"
          fontWeight="bold"
          textAlign="center"
          marginBottom="$4"
        >
          HomeGuardian Data Portal
        </Text>

        <Form onSubmit={handleLogin}>
          <YStack space="$4">
            <Input
              placeholder="Username"
              value={username}
              onChangeText={setUsername}
              autoCapitalize="none"
            />

            <Input
              placeholder="Password"
              value={password}
              onChangeText={setPassword}
              secureTextEntry
              autoCapitalize="none"
            />

            {error ? (
              <Text color="$red10" textAlign="center">
                {error}
              </Text>
            ) : null}

            <XStack marginTop="$2">
              <Button
                flex={1}
                backgroundColor="$blue10"
                color="white"
                onPress={handleLogin}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </XStack>
          </YStack>
        </Form>
      </YStack>
    </YStack>
  );
};
